import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const CreditNoteListDetails = ({ invoiceId }) => { 
  const [creditNotes, setCreditNotes] = useState([]); 

  useEffect(() => { 
    const fetchCreditNotes = async () => { 
      try {      
     
        var url =  `${API_DOMAIN}${API_ROUTES.credit_note}?invoice_id=${invoiceId}`;       
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 

        setCreditNotes(response.data); 
      } catch (error) { 
        console.error('Error fetching credit notes:', error); 
      } 
    }; 

    fetchCreditNotes(); 
  }, [invoiceId]); 

  const columns = [ 
    { label: 'Amount', value: 'amount' }, 
    { label: 'Reason', value: 'reason' }, 
    { label: 'Issued Date', value: 'issued_date' }, 
    { label: 'Created At', value: 'created_at' }, 
    { label: 'Updated At', value: 'updated_at' }, 
  ]; 

  const handleViewDetails = (creditNoteId) => { 
    //console.log('View Details', creditNoteId); 
    const encodedId = btoa(creditNoteId);
    window.location.href = `/credit/note/details/${encodedId}`; 
  }; 

  const actionButtons = [ 
    { label: 'View Details', handler: handleViewDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={creditNotes} actionButtons={actionButtons} />; 
}; 

export default CreditNoteListDetails;